/* eslint-disable */
import { useEffect, useState } from "react";
import "../../styles/RelajacionPage.css";
import relajacionTitle from "../../assets/titulos/relajacion.png";
import relax from "../../assets/titles/relax.png";
import relief from "../../assets/relax/relief.png";
import mind from "../../assets/relax/mind.png";
import motion from "../../assets/relax/motion.png";

import { useTranslation } from "react-i18next";
import LocalizedTitleImage from "../../components/UseLanguage";
import menuIcon from "../../assets/menu.png";

const RelajacionPage = () => {
  const { t } = useTranslation();

  const secciones = [
    {
      nombre: t("relajacion.meditacion.nombre"),
      descripcion: t("relajacion.meditacion.descripcion"),
      imagen: mind,
    },
    {
      nombre: t("relajacion.masajes.nombre"),
      descripcion: t("relajacion.masajes.descripcion"),
      imagen: relief,
    },
    {
      nombre: t("relajacion.entrenamiento.nombre"),
      descripcion: t("relajacion.entrenamiento.descripcion"),
      imagen: motion,
    },
  ];

  const [flipped, setFlipped] = useState(Array(secciones.length).fill(false));

  const toggleFlip = (index: number) => {
    setFlipped((prev) => {
      const next = [...prev];
      next[index] = !next[index];
      return next;
    });
  };

  return (
    <div className="relajacion-page fade-tab">
      <div className="menu-icon-div">
        <img src={menuIcon} />
      </div>
      <div className="relajacion-title-wrapper">
        <LocalizedTitleImage
          imageEn={relax}
          imageEs={relajacionTitle}
          className="relajacion-title-img"
        />
      </div>

      <div className="card-container">
        {secciones.map((sec, i) => (
          <div
            key={i}
            className={`flip-card ${flipped[i] ? "flipped" : ""}`}
            onClick={() => toggleFlip(i)}
          >
            <div className="flip-card-inner">
              <div className="flip-card-front">
                <img src={sec.imagen} />
              </div>
              <div className="flip-card-back">
                <h3 className="flip-card-back-title">{sec.nombre}</h3>
                <p>{sec.descripcion}</p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RelajacionPage;
